import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import styled from "@emotion/styled";
import isThemeDefault from "../../helpers/isThemeDefault";

//style rules
import { Animation, Colors, Typography } from "../../styles";

const CastMemberModal = ({ toggleModal, castMember }) => {
	const { name, content } = castMember;

	let isDarkMode = isThemeDefault();

	// replace /n with <br /> in order to keep original formatting
	const formattedContent = content.replace(/\n/g, "<br />");

	return (
		<Overlay
			className="backdrop"
			variants={Animation.modal.overlayVariants}
			initial="hidden"
			animate="visible"
			exit="hidden"
			onClick={() => toggleModal()}
			aria-labelledby="modal-title"
			isDarkMode={isDarkMode}
		>
			<Modal
				variants={Animation.modal.modalVariants}
				onClick={(e) => e.stopPropagation()}
				role="dialog"
				aria-modal="true"
				isDarkMode={isDarkMode}
			>
				<CloseIcon
					onClick={() => toggleModal()}
					width="19"
					height="18"
					viewBox="0 0 19 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-label="Close modal"
					isDarkMode={isDarkMode}
				>
					<path
						id="menu-close"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1.07884 17.6699C0.575402 17.1664 0.657033 16.2685 1.26116 15.6644L7.64235 9.28317L1.62591 3.26672C1.02178 2.66259 0.940187 1.76462 1.44359 1.26122C1.94703 0.757779 2.84496 0.83941 3.44909 1.44354L9.46554 7.45998L15.482 1.44353C16.0861 0.839406 16.984 0.757775 17.4875 1.26122C17.9909 1.76466 17.9093 2.66259 17.3052 3.26672L11.2887 9.28317L17.6699 15.6644C18.274 16.2685 18.3557 17.1664 17.8522 17.6699C17.3488 18.1733 16.4509 18.0917 15.8467 17.4875L9.46554 11.1064L3.08434 17.4875C2.48022 18.0917 1.58225 18.1733 1.07884 17.6699Z"
						fill="white"
					/>
				</CloseIcon>
				<FlexContainer>
					<Name id="modal-title" dangerouslySetInnerHTML={{ __html: name }} />
					{content && (
						<p dangerouslySetInnerHTML={{ __html: formattedContent }} />
					)}
				</FlexContainer>
			</Modal>
		</Overlay>
	);
};

export default CastMemberModal;

CastMemberModal.propTypes = {
	castMember: PropTypes.object,
	toggleModal: PropTypes.func,
};

const Overlay = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: ${(props) => props.isDarkMode? 'rgba(35, 35, 35, 0.7)' : 'rgba(245,243,240, 0.8)'};
	z-index: 1000;
	cursor: pointer;
`;

const Modal = styled(motion.div)`
	position: relative;
	height: 50%;
	margin: 4.4rem 2.2rem 0;
	padding: 7.4rem 1.5rem 3.2rem;
	background: ${(props) => props.isDarkMode? Colors.base.darkGrey : Colors.base.beigeDark};
	cursor: default;
	overflow: scroll;
`;

const FlexContainer = styled.div`
	display: flex;
	gap: 1.3rem;
	flex-direction: column;
`;

const Name = styled.h3`
	font-size: 1.6rem;
	line-height: 1.8rem;
	font-weight: ${Typography.fontWeight.bold};
	margin-bottom: 0;
`;

const CloseIcon = styled.svg`
	position: absolute;
	top: 2.1rem;
	right: 1.9rem;
	cursor: pointer;

	> path {
		fill: ${(props) => !props.isDarkMode && Colors.base.black};
	}
`;
